import {
    GET_ASSET_EONE_DETAILS,
    SET_ASSET_EONE_DETAILS,
    GET_ASSET_AUDIT_REPORT_DETAILS,
    SET_ASSET_AUDIT_REPORT_DETAILS
} from "./AssetEoneDetailsType"

const getAssetEoneDetails= (payload: any) => ({
    type: GET_ASSET_EONE_DETAILS,
    payload
});

const setAssetEoneDetails = (assetEoneDetails: any) => ({
    type: SET_ASSET_EONE_DETAILS,
    assetEoneDetails
});

export {
    getAssetEoneDetails,
    setAssetEoneDetails,
}